import D1 from "../../components/ExcerciseTypes/Design/TypeIn";
import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import DesignUnderLine from "../../components/ExcerciseTypes/Design/DesignUnderLine";

const json = {
  4: { // Exercise num
    unit: 'Unit 6',
    id: 'SB3-U6-P47-E1',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page47/E1/Key/answerKey.png',
    isAllowSubmit: false,
    maxLength: 1,
    textAlign: 'center',
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page47/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page47/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page47/E1/3.jpg', input: true, answer: "b" },
        { url: 'img/FriendsPlus/Page47/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page47/E1/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page47/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page47/E1/7.jpg', input: true, answer: "d" },
        { url: 'img/FriendsPlus/Page47/E1/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page47/E1/9.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page47/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page47/E1/11.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page47/E1/12.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page47/E1/13.jpg' },
      ],
    ],
  },
  5: { // Exercise num
    unit: 'Unit 6',
    id: 'SB3-U6-P47-E2',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: 'img/FriendsPlus/Page47/E2/1.jpg' }]],
  },
  6: { // Exercise num
    unit: "Unit 6",
    id: "SB3-U6-P47-E3",
    audio: "",
    video: "",
    component: DesignUnderLine,
    hideBtnFooter: true,
    totalInput: 5,
    exerciseKey: "img/FriendsPlus/Page47/E3/Key/answerKey.png",
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page47/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page47/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page47/E3/3.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page47/E3/4.jpg' },
        { url: 'img/FriendsPlus/Page47/E3/5.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page47/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page47/E3/7.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page47/E3/8.jpg' },
        { url: 'img/FriendsPlus/Page47/E3/9.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page47/E3/10.jpg' },
        { url: 'img/FriendsPlus/Page47/E3/11.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page47/E3/12.jpg' },
        { url: 'img/FriendsPlus/Page47/E3/13.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page47/E3/14.jpg' },
        { url: 'img/FriendsPlus/Page47/E3/15.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page47/E3/16.jpg' },
        { url: 'img/FriendsPlus/Page47/E3/17.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page47/E3/18.jpg' },
        { url: 'img/FriendsPlus/Page47/E3/19.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page47/E3/20.jpg' },
        { url: 'img/FriendsPlus/Page47/E3/21.jpg', input: 4 },
        { url: 'img/FriendsPlus/Page47/E3/22.jpg' },
        { url: 'img/FriendsPlus/Page47/E3/23.jpg', input: 4, isCorrect: true },
        { url: 'img/FriendsPlus/Page47/E3/24.jpg' },
        { url: 'img/FriendsPlus/Page47/E3/25.jpg', input: 4 },
        { url: 'img/FriendsPlus/Page47/E3/26.jpg' },
        { url: 'img/FriendsPlus/Page47/E3/27.jpg', input: 5 },
        { url: 'img/FriendsPlus/Page47/E3/28.jpg' },
        { url: 'img/FriendsPlus/Page47/E3/29.jpg', input: 5, isCorrect: true },
        { url: 'img/FriendsPlus/Page47/E3/30.jpg' },
        { url: 'img/FriendsPlus/Page47/E3/31.jpg', input: 5 },
        { url: 'img/FriendsPlus/Page47/E3/32.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page47/E3/33.jpg' },
      ],
    ],
  },
  7: { // Exercise num
    unit: 'Unit 6',
    id: 'SB3-U6-P47-E4',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: 'img/FriendsPlus/Page47/E4/1.jpg' }]],
  },
}

export default json;